<!-- Offline Indicator -->
<div 
  *ngIf="showIndicator" 
  class="fixed top-0 left-0 right-0 z-50 animate-slide-down"
  role="alert"
  aria-live="assertive"
>
  <div class="bg-yellow-500 dark:bg-yellow-600 text-white px-4 py-3 shadow-lg">
    <div class="max-w-7xl mx-auto flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <!-- Offline Icon -->
        <svg class="w-6 h-6 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"/>
        </svg>
        
        <!-- Message -->
        <div>
          <p class="font-semibold text-sm">You're offline</p>
          <p class="text-xs opacity-90">Some features may be limited. Your data will sync when you're back online.</p>
        </div>
      </div>

      <!-- Dismiss button -->
      <button
        (click)="dismiss()"
        class="text-white hover:text-yellow-100 transition-colors ml-4"
        aria-label="Dismiss offline notification"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
  </div>
</div>











